<div class="container" *ngIf="isLoading()">
  <!-- Match info column -->
  <div class="col-md-7">
    <!-- Video header -->
    <app-match-video-header
      *ngIf="videoHeaderContent"
      [content]="videoHeaderContent">
    </app-match-video-header>
    <!-- Match header -->
    <app-match-score-header class="score-header"></app-match-score-header>
    <!-- Nav bar -->
    <nav class="nav-bar" (click)="onNavClick()">
      <a *ngIf="matchDetailViewService.showTabs.overview" routerLink="uebersicht" routerLinkActive="active"
         [replaceUrl]="true">
        <span>Infos</span>
      </a>
      <a *ngIf="matchDetailViewService.showTabs.liveticker" routerLink="liveticker" routerLinkActive="active"
         [replaceUrl]="true">
        <span>Liveticker</span>
      </a>
      <a *ngIf="matchDetailViewService.showTabs.videos" routerLink="videos" routerLinkActive="active"
         [replaceUrl]="true">
        <span>Videos</span>
      </a>
      <a *ngIf="matchDetailViewService.showTabs.lineup" routerLink="aufstellung" routerLinkActive="active"
         [replaceUrl]="true">
        <span>Aufstellung</span>
      </a>
    </nav>
    <router-outlet></router-outlet>
  </div>
  <!-- League info column -->
  <div class="col-md-5" *ngIf="!leagueLoading">
    <lib-league-table
      class="d-none d-md-block"
      [smallTable]="true"
      [league]="league"
      [highlightTeamId]="teamId"
      [filterForTeamId]="matchDetailViewService.data.homeTeam.id"></lib-league-table>
    <lib-ad [breakpoints]="[columnRightBreakpoint]"></lib-ad>
    <app-current-games
      [leagueId]=" showGamesFromLeague ? league?.id : null"
      [teamId]="showGamesFromLeague ? null : matchDetailViewService.data?.currentTeamId"
      [readableId]="league?.readable_id">
    </app-current-games>
  </div>
</div>
